import React from 'react';
import { SkeletonItem } from '@atlaskit/menu';
import { Box, xcss } from '@atlaskit/primitives';
import { ListFallback } from './ListFallback.tsx';

export const SidebarFallback = (): React.JSX.Element => (
	<Box>
		<Box xcss={containerStyle}>
			<SkeletonItem isShimmering width="120px" />
			<SkeletonItem isShimmering width="100%" />
			<ListFallback />
		</Box>
	</Box>
);

const containerStyle = xcss({
	padding: 'space.250',
});
